import { getLocalItem } from "./StorageTools"
import moment from "moment/moment"
import { formatMoney } from "./GeneralTools"
import FidelityController from "../controllers/FidelityController"

export const getLocalUser = () => {
  return getLocalItem("user", true)
}

// Extrai email/telefone dos contatos do cliente (fk_id_contact: 1 = celular, 2 = email).
// Usado como match data dos eventos da Conversion API — manter formato cru, a API normaliza/hasheia.
export const getCustomerEmailPhone = (contacts = []) => ({
  email: contacts.find((c) => c.fk_id_contact === 2)?.val_contact || null,
  phone: contacts.find((c) => c.fk_id_contact === 1)?.val_contact || null,
})

export const userIsConnected = () => {
  const user = getLocalItem("user", true)
  return !!user
}

export const getFidelityProgress = (fidelity, userFidelitiesPoints = []) => {
  let actual = 0
  let total = 0
  let progress = ""
  let readyToFinish = false
  const usageFidelityIds = []
  const expiredPoints = []
  let fidelityUsageControl = getLocalItem("fidelityUsageControl", true) || {}

  const usedFidelity = fidelityUsageControl[fidelity.id_fidelity]

  if (userFidelitiesPoints.length > 0) {
    for (const userFidelityPoint of userFidelitiesPoints) {
      //Verificando ponto expirado
      const compareDate = moment(moment().format("YYYY-MM-DD")).subtract(fidelity.expire_time, "days")
      const pointDate = moment(userFidelityPoint.dt_created_at)
      if (pointDate.isBefore(compareDate) && fidelity.expire_time > 0) {
        expiredPoints.push(userFidelityPoint.id_fidelity_customer)
        continue
      }

      //Tratando pontos da campanha de fidelidade
      if (userFidelityPoint.fk_id_fidelity === fidelity.id_fidelity) {
        //Verificando pontos que já foram utilizados.
        if (usedFidelity) {
          let continuePoints = true
          for (const { pointsUsed } of usedFidelity) {
            if (pointsUsed.includes(userFidelityPoint.id_fidelity_customer)) {
              continuePoints = false
              continue
            }
          }
          if (!continuePoints) {
            continue
          }
        }
        usageFidelityIds.push(userFidelityPoint.id_fidelity_customer)
        if (fidelity.qty_type === "value") {
          actual += userFidelityPoint.val_order
        } else {
          actual++
        }
      }
    }

    total = fidelity.qty_type === "value" ? formatMoney(fidelity.minimum_value, "R$ ", false) : fidelity.minimum_value
    progress = `${(actual / fidelity.minimum_value) * 100}%`
    readyToFinish = actual / fidelity.minimum_value >= 1

    if (fidelity.qty_type === "value") actual = formatMoney(actual, "R$ ", false)
  } else {
    total = fidelity.qty_type === "value" ? formatMoney(fidelity.minimum_value, "R$ ", false) : fidelity.minimum_value
  }

  if (expiredPoints && expiredPoints.length > 0) {
    fidelityPointExpired(expiredPoints)
  }

  return {
    actual,
    total,
    progress,
    readyToFinish,
    usageFidelityIds,
  }
}

// Método para remover pontos expirados
export const fidelityPointExpired = (expiredPoints) => {
  FidelityController.deleteExpiredPoint(expiredPoints).then((responseRemoveExpired) => {
    if (responseRemoveExpired.status === 200) {
      console.info(responseRemoveExpired.message)
    }
    if (responseRemoveExpired.status === 500) {
      console.error(responseRemoveExpired.message)
    }
  })
}

// Método para pegar o saldo da conta de cashback do cliente.
export const getCashbackValue = (movements) => {
  let value = 0
  let input = 0
  let output = 0

  if (!!movements) {
    for (const movement of movements) {
      if (["input", "adjust"].includes(movement.type_movement_customer_account)) {
        value += movement.val_movement
        input += movement.val_movement
      }
      if (movement.type_movement_customer_account === "output") {
        value -= movement.val_movement
        output -= movement.val_movement
      }
    }
  }

  return { value, input, output }
}
